export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const SAVE_SHIPPING_INFO = 'SAVE_SHIPPING_INFO';
